import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_REVIEW_CRITERIAS](state, data) {
    console.log('mutation ', data)
    state.allReviewCriterias = data
  },
}
